import { addMessages } from '@hana/i18n';

// Khoá chuỗi của Việc & Duyệt (iPad / điện thoại / chi tiết / bảng phải). Mã nghiệp vụ và dữ liệu không dịch.
addMessages('vi', {
  'tasks.retry': 'Thử lại',
  'tasks.backToList': 'Về danh sách việc',
  'tasks.note': 'Ghi chú',
  'tasks.noTodo': 'Không còn việc nào.',
  'tasks.briefTitle': 'Tóm tắt đầu ngày',
  'tasks.briefHide': 'Ẩn tóm tắt',
  'tasks.detail': 'Chi tiết',
  'tasks.gateBlock': 'Chặn',
  'tasks.gateWarn': 'Cảnh báo',
  'tasks.all': 'Tất cả',
  'tasks.gateOnly': 'Bị chặn / cảnh báo',
  'tasks.noMatch': 'Không có mục khớp bộ lọc.',
  'tasks.pickOne': 'Chọn một việc hoặc phiếu duyệt để mở trang chi tiết.',
  'tapv.okToast': 'Đã đồng ý · {k}',
  'tapv.okBulkToast': 'Đã đồng ý {n} phiếu · chuyển bước kế theo ghế',
  'tapv.typeBtn': 'Loại phiếu ▾',
  'tapv.typeN': '{n} loại ▾',
  'tapv.searchLbl': 'Tìm việc',
  'tapv.search': 'Tìm phiếu, người đề nghị, job…',
  'tapv.filterLbl': 'Lọc loại phiếu',
  'tapv.typeHd': 'Loại phiếu',
  'tapv.oneOf': 'là một trong',
  'tapv.filtering': '{n} loại đang lọc',
  'tapv.allTypes': 'Mọi loại phiếu',
  'tapv.unpick': 'Bỏ chọn',
  'tapv.waitMe': 'Chờ anh',
  'tapv.oldest': 'Cũ nhất',
  'tapv.days': '{n} ngày',
  'tapv.bulk': 'Duyệt hàng loạt',
  'tapv.picked': 'Đã chọn {n} phiếu',
  'tapv.flagged': '{n} phiếu có cờ phải mở từng phiếu, không tính vào duyệt hàng loạt',
  'tapv.nextSeat': 'Mỗi phiếu đi tiếp bước kế theo ghế trong ma trận duyệt',
  'tapv.rejectN': 'Từ chối {n}',
  'tapv.approveN': 'Đồng ý {n} phiếu',
  'tapv.emptyT': 'Không có phiếu nào chờ anh duyệt',
  'tapv.listLbl': 'Phiếu chờ duyệt',
  'tapv.pickAll': 'Chọn tất cả phiếu đang hiện',
  'tapv.pendingHd': '{n} phiếu chờ · {k} loại',
  'tapv.seatHint': 'Người duyệt hiện theo ghế · ghế trống leo lên ghế cấp trên',
  'tapv.emptyD': 'Không có phiếu nào chờ anh duyệt.',
  'tapv.pickOne': 'Chọn {a}',
  'tapv.openSrc': 'Mở chứng từ gốc',
  'tapv.sameReq': 'Cùng đơn ở mục Duyệt đơn',
  'tapv.openMee': 'Mở HANA Mee ↗',
  'tapv.askedBy': 'đề nghị: {a}',
  'tapv.step': 'Bước {i}/{n} · {seat}',
  'tapv.okDone': '✓ Đã đồng ý',
  'tapv.ask': 'Hỏi thêm',
  'tapv.reject': 'Từ chối',
  'tapv.approveStep': 'Đồng ý bước {i}',
  'tapv.approve': 'Đồng ý',
});
addMessages('en', {
  'tasks.retry': 'Retry',
  'tasks.backToList': 'Back to task list',
  'tasks.note': 'Note',
  'tasks.noTodo': 'Nothing left to do.',
  'tasks.briefTitle': "Today's brief",
  'tasks.briefHide': 'Hide brief',
  'tasks.detail': 'Details',
  'tasks.gateBlock': 'Blocked',
  'tasks.gateWarn': 'Warning',
  'tasks.all': 'All',
  'tasks.gateOnly': 'Blocked / warning',
  'tasks.noMatch': 'No items match the filter.',
  'tasks.pickOne': 'Pick a task or approval to open its detail page.',
});

// Việc & Duyệt › Tôi đang thay · Team
addMessages('vi', {
  'pp.search': 'Tìm việc',
  'pp.searchPh': 'Tìm việc, job, khách…',
  'pp.noWrite': 'Chưa mở ghi ở bản này',
  'pp.absent': 'Vắng hôm nay',
  'pp.delegIn': 'Uỷ quyền đang nhận',
  'pp.emptyDel': 'Anh không đang thay ai',
  'pp.coverFor': 'Thay cho {k}',
  'pp.live': 'Đang hiệu lực',
  'pp.scope': 'Phạm vi',
  'pp.time': 'Thời gian',
  'pp.apprRight': 'Quyền duyệt',
  'pp.inPeriod': 'Việc trong kỳ',
  'pp.overdue': 'Quá hạn',
  'pp.done': 'Đã xong',
  'pp.delTasks': 'Việc phát sinh trong kỳ thay',
  'pp.delTasksTip': 'KPI đúng / trễ hạn tính cho người thay',
  'pp.coverForLc': 'thay cho {k}',
  'pp.openBy': 'Việc mở theo người',
  'pp.barAria': '{k} {open} mở, {over} quá hạn, {wait} chờ bên ngoài',
  'pp.teamOver': 'Quá hạn cả team',
  'pp.onTime': 'Đúng hạn',
  'pp.emptyTeam': 'Chưa có ai trong team',
  'pp.inTime': 'trong hạn',
  'pp.overLc': 'quá hạn',
  'pp.waitExt': 'chờ ngoài',
  'pp.openLc': 'mở',
  'pp.lateLc': 'trễ',
  'pp.ot30': 'Đúng hạn 30 ngày',
  'pp.ot30team': 'Đúng hạn 30 ngày · cả team',
  'pp.gaugeAria': 'Đúng hạn 30 ngày cả team {pct}, {open} việc mở, {over} quá hạn',
  'pp.openTasks': 'Việc mở',
  'pp.lowest': 'Thấp nhất',
  'pp.load': 'Tải việc theo người',
  'pp.thPerson': 'Người · ghế',
  'pp.waitOut': 'Chờ bên ngoài',
  'pp.gate': 'Cổng quá hạn',
  'pp.abnormal': 'cao bất thường',
  'pp.unlockTip': 'Trưởng bộ phận mở tạm 2h có ghi lý do; mọi lần mở đều vào nhật ký',
  'pp.unlocked': 'Đã mở tạm · còn 2h',
  'pp.unlockN': 'Mở tạm 2h · {n} việc chặn',
  'pp.unlock': 'Mở tạm 2h',
  'pp.noBlock': 'Không chặn',
  'pp.escal': 'Leo thang',
  'pp.escalUp': 'Đang leo thang lên anh',
});
addMessages('en', {
  'pp.search': 'Search tasks',
  'pp.searchPh': 'Search tasks, jobs, customers…',
  'pp.noWrite': 'Writing is not enabled in this version',
  'pp.absent': 'Away today',
  'pp.delegIn': 'Active delegations',
  'pp.emptyDel': 'You are not covering for anyone',
  'pp.coverFor': 'Covering for {k}',
  'pp.live': 'In effect',
  'pp.scope': 'Scope',
  'pp.time': 'Period',
  'pp.apprRight': 'Approval rights',
  'pp.inPeriod': 'Tasks in period',
  'pp.overdue': 'Overdue',
  'pp.done': 'Done',
  'pp.delTasks': 'Tasks arising while covering',
  'pp.delTasksTip': 'On-time / late KPI counts for the substitute',
  'pp.coverForLc': 'covering for {k}',
  'pp.openBy': 'Open tasks by person',
  'pp.barAria': '{k} {open} open, {over} overdue, {wait} waiting externally',
  'pp.teamOver': 'Team overdue',
  'pp.onTime': 'On time',
  'pp.emptyTeam': 'No one in the team yet',
  'pp.inTime': 'on time',
  'pp.overLc': 'overdue',
  'pp.waitExt': 'waiting external',
  'pp.openLc': 'open',
  'pp.lateLc': 'late',
  'pp.ot30': 'On time, 30 days',
  'pp.ot30team': 'On time, 30 days · whole team',
  'pp.gaugeAria': 'On time, 30 days, whole team {pct}, {open} open, {over} overdue',
  'pp.openTasks': 'Open',
  'pp.lowest': 'Lowest',
  'pp.load': 'Workload by person',
  'pp.thPerson': 'Person · seat',
  'pp.waitOut': 'Waiting externally',
  'pp.gate': 'Overdue gate',
  'pp.abnormal': 'unusually high',
  'pp.unlockTip': 'Department head unlocks for 2h with a reason; every unlock is logged',
  'pp.unlocked': 'Unlocked · 2h left',
  'pp.unlockN': 'Unlock 2h · {n} blocking',
  'pp.unlock': 'Unlock 2h',
  'pp.noBlock': 'No block',
  'pp.escal': 'Escalation',
  'pp.escalUp': 'Escalated to you',
});

// Việc & Duyệt › Việc của tôi (TasksScreen)
addMessages('vi', {
  'ts.title': 'Việc & Duyệt',
  'ts.home': 'Trang chủ',
  'ts.backHome': 'Về Trang chủ',
  'ts.groups': 'Nhóm việc',
  'ts.notif': 'Thông báo · {n} chưa đọc',
  'ts.notifToast': '{n} thông báo chưa đọc',
  'ts.more': 'Thao tác khác',
  'ts.task': 'Việc',
  'ts.kind': 'Loại việc',
  'ts.byScreen': 'Việc theo màn đang làm',
  'ts.byJob': 'Lọc theo job',
  'ts.allJobs': 'Mọi job',
  'ts.blocking': 'Đang chặn',
  'ts.onlyMine': 'Chỉ của tôi',
  'ts.today': 'Hôm nay',
  'ts.emptyT': 'Không còn việc nào hôm nay',
  'ts.emptyD': 'Việc mới sinh tự động khi dữ liệu job, booking, hoá đơn thay đổi.',
  'ts.addMemo': 'Thêm việc ghi nhớ',
  'ts.done7': 'Đã xong 7 ngày qua',
  'ts.noMatch': 'Không có việc khớp bộ lọc.',
  'ts.clear': 'Xoá lọc',
  'ts.doneOf': 'Xong: {title}',
  'ts.clockStop': 'Dừng đồng hồ',
  'ts.blockedBy': 'Đang chặn: {a}',
  'ts.reasonReq': 'Đi tiếp phải ghi một dòng lý do: {a}',
  'ts.reason': 'Lý do: {r}',
  'ts.handle': 'Xử lý',
  'ts.delMemo': 'Xoá ghi nhớ',
  'ts.ext4': 'Gia hạn 4 giờ làm việc',
  'ts.noExt': 'Loại việc {c} không được gia hạn',
  'ts.extN': 'Gia hạn +4 giờ làm việc ({n}/3)',
  'ts.waitTip': 'Chờ bên ngoài — dừng đồng hồ, ghi lý do',
  'ts.moreMenu': 'Thêm',
  'ts.otherGroups': 'Nhóm việc khác',
  'ts.doneAt': 'xong {at}',
  'ts.late210': 'Trễ 2h 10′',
  'ts.lateLbl': 'Trễ hạn',
});
addMessages('en', {
  'ts.title': 'Tasks & Approvals',
  'ts.home': 'Home',
  'ts.backHome': 'Back to Home',
  'ts.groups': 'Task groups',
  'ts.notif': 'Notifications · {n} unread',
  'ts.notifToast': '{n} unread notifications',
  'ts.more': 'More actions',
  'ts.task': 'Task',
  'ts.kind': 'Task type',
  'ts.byScreen': 'Tasks by current screen',
  'ts.byJob': 'Filter by job',
  'ts.allJobs': 'All jobs',
  'ts.blocking': 'Blocking',
  'ts.onlyMine': 'Mine only',
  'ts.today': 'Today',
  'ts.emptyT': 'Nothing left for today',
  'ts.emptyD': 'New tasks are generated automatically when job, booking or invoice data changes.',
  'ts.addMemo': 'Add a memo task',
  'ts.done7': 'Done in the last 7 days',
  'ts.noMatch': 'No tasks match the filter.',
  'ts.clear': 'Clear filter',
  'ts.doneOf': 'Done: {title}',
  'ts.clockStop': 'Clock stopped',
  'ts.blockedBy': 'Blocked: {a}',
  'ts.reasonReq': 'Continuing requires a one-line reason: {a}',
  'ts.reason': 'Reason: {r}',
  'ts.handle': 'Handle',
  'ts.delMemo': 'Delete memo',
  'ts.ext4': 'Extend by 4 working hours',
  'ts.noExt': 'Task type {c} cannot be extended',
  'ts.extN': 'Extend +4 working hours ({n}/3)',
  'ts.waitTip': 'Waiting externally — stops the clock, give a reason',
  'ts.moreMenu': 'More',
  'ts.otherGroups': 'Other task groups',
  'ts.doneAt': 'done {at}',
  'ts.late210': 'Late 2h 10′',
  'ts.lateLbl': 'Overdue',
  'tapv.okToast': 'Approved · {k}',
  'tapv.okBulkToast': 'Approved {n} requests · moved to the next seat',
  'tapv.typeBtn': 'Request type ▾',
  'tapv.typeN': '{n} types ▾',
  'tapv.searchLbl': 'Search tasks',
  'tapv.search': 'Search requests, requester, job…',
  'tapv.filterLbl': 'Filter by request type',
  'tapv.typeHd': 'Request type',
  'tapv.oneOf': 'is one of',
  'tapv.filtering': '{n} types filtered',
  'tapv.allTypes': 'All request types',
  'tapv.unpick': 'Clear selection',
  'tapv.waitMe': 'Waiting on you',
  'tapv.oldest': 'Oldest',
  'tapv.days': '{n} days',
  'tapv.bulk': 'Bulk approval',
  'tapv.picked': '{n} requests selected',
  'tapv.flagged': '{n} requests carry a flag and must be opened one by one — not counted in bulk approval',
  'tapv.nextSeat': 'Each request moves to the next seat in the approval matrix',
  'tapv.rejectN': 'Reject {n}',
  'tapv.approveN': 'Approve {n} requests',
  'tapv.emptyT': 'No requests waiting for your approval',
  'tapv.listLbl': 'Requests awaiting approval',
  'tapv.pickAll': 'Select all visible requests',
  'tapv.pendingHd': '{n} pending · {k} types',
  'tapv.seatHint': 'Approver shown by seat · an empty seat escalates to the seat above',
  'tapv.emptyD': 'No requests waiting for your approval.',
  'tapv.pickOne': 'Select {a}',
  'tapv.openSrc': 'Open source document',
  'tapv.sameReq': 'Same request under Approvals',
  'tapv.openMee': 'Open HANA Mee ↗',
  'tapv.askedBy': 'requested by: {a}',
  'tapv.step': 'Step {i}/{n} · {seat}',
  'tapv.okDone': '✓ Approved',
  'tapv.ask': 'Ask more',
  'tapv.reject': 'Reject',
  'tapv.approveStep': 'Approve step {i}',
  'tapv.approve': 'Approve',
});
